import React from 'react';
import PropTypes from 'prop-types';
import customer from '../../types/customer';
import translator from '../../translations/drupalTranslator';
import CustomerContactInfoCompSelect from './CustomerContactInfoCompSelect';

const CustomerContactInfoTitle = props => (
  <CustomerContactInfoCompSelect
    {...props}
    clearable
    errorMessages={{
      'field_is_required': 'The Title field is required',
    }}
    label="Title"
    name="title"
    options={props.options.map(x => ({text: translator.translate(x.label), value: x.value}))}
    value={props.customer.title}
  />
);
CustomerContactInfoTitle.PropTypes = {
  customer: PropTypes.func.isRequired,
  options: PropTypes.shape([]).isRequired,
};

export default CustomerContactInfoTitle;
